<nav class="layout-breadcrumb">
  <ol>
    @for (item of breadcrumbs$ | async; track item; let last = $last) {
      <li [ngClass]="{ 'text-black-alpha-90': last }">{{item.label}}</li>
      @if (!last) {
        <li class="layout-breadcrumb-chevron"> <i class="pi pi-angle-left"></i> </li>
      }
    }
  </ol>
</nav>